import React from 'react';
import { ArrowRight } from 'lucide-react';

export function Footer() {
  return (
    <footer className="border-t border-[#333] fixed bottom-0 w-full bg-[#0A0A0A]">
      <div className="container mx-auto px-4 py-8">
        <p className="text-center text-zinc-400">
          Built with 🧡 by <a href="https://ae.studio/" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-400 transition-colors">AE Studio</a> AI Powered Agents, for AI Agents everywhere. See what we can built for you <a href="https://ae.studio/ai-solutions?utm_source=sds&utm_medium=referral&utm_campaign=aiagentsee&utm_content=footer" target="_blank" rel="noopener noreferrer" className="group text-orange-500 hover:text-orange-400 transition-colors">here <ArrowRight className="inline w-4 h-4 text-orange-500 group-hover:text-orange-400 group-hover:translate-x-1 transition-all" /></a>
        </p>
      </div>
    </footer>
  );
} 